import { IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonItem, IonLabel, IonSkeletonText } from '@ionic/react';
import { IonCardWrapper } from './RepairOrderCard.styles';

const RepairOrderCardSkeleton: React.FC = () => {
  return (
    <IonCardWrapper>
      <IonCardHeader>
        <IonCardTitle>
          <IonSkeletonText animated style={{ width: '50%' }} />
        </IonCardTitle>
        <IonCardSubtitle>
          <IonSkeletonText animated style={{ width: '20%' }} />
        </IonCardSubtitle>
        <IonCardTitle>
          <IonItem lines="none">
            <IonLabel>
              <IonSkeletonText animated style={{ width: '100%' }} />
            </IonLabel>
          </IonItem>
        </IonCardTitle>
      </IonCardHeader>

      <IonCardContent>
        <IonSkeletonText animated style={{ width: '90%' }} />
      </IonCardContent>
    </IonCardWrapper>
  );
};

export default RepairOrderCardSkeleton;
